import React, { Component } from "react";
import { Dropdown } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import Service from "./service";

import "./BrandGroupDropdown.css";

export const ALL_BRANDS = 0;

const ALL_BRANDS_KEY = "all-brands";

const sortByName = (a, b) => a.name.localeCompare(b.name);

const searchBrandGroups = (options, query) => {
  const search = query.toLowerCase();
  const matchingKeys = new Set(options.filter(option => typeof option.text === "string" && option.text.toLowerCase().includes(search)).map(option => option.groupKey));

  return options.filter(option => matchingKeys.has(option.groupKey));
};

class BrandGroupDropdown extends Component {
  state = {
    brands: [],
    brandGroups: [],
    isLoading: false,
  };

  componentDidMount() {
    this.setState({ isLoading: true }, () => {
      Promise.all([Service.getBrands(), Service.getBrandGroups()])
        .then(([brandsResult, brandGroupsResult]) => {
          this.setState({
            brands: (brandsResult?.data?.data?.brands || []).filter(brand => brand.is_active),
            brandGroups: brandGroupsResult?.data?.data?.brand_groups || [],
            isLoading: false,
          });
        })
        .catch(error => {
          console.error("Error getting brands and brand groups.", error);
          this.setState({ brands: [], brandGroups: [], isLoading: false });
        });
    });
  }

  getBrandsByGroupID = () => {
    const map = new Map();
    this.state.brands.forEach(brand => {
      if (!brand.brand_group_id) return;
      map.set(brand.brand_group_id, [...(map.get(brand.brand_group_id) || []), brand]);
    });
    return map;
  };

  getSelectedBrandGroups = brandGroupIDs => this.state.brandGroups.filter(group => brandGroupIDs.includes(group.id));

  getOptions = () => {
    const { t, showAllBrands, value } = this.props;
    const brandsByGroupID = this.getBrandsByGroupID();
    const selectedGroupIDs = value || [];

    const allBrandsOption = showAllBrands ? [{ key: ALL_BRANDS, value: ALL_BRANDS, text: t("all_brands").message || "All brands", groupKey: ALL_BRANDS_KEY }] : [];

    const groupOptions = [...this.state.brandGroups].sort(sortByName).flatMap(group => {
      const isSelected = selectedGroupIDs.includes(group.id);
      const groupBrands = [...(brandsByGroupID.get(group.id) || [])].sort(sortByName);
      if (!groupBrands.length && !isSelected) return [];

      const groupOption = { key: group.id, value: group.id, text: group.name, className: "brand-group-header", groupKey: group.id };
      if (isSelected) return [groupOption];

      return [
        groupOption,
        ...groupBrands.map(brand => ({
          key: `brand-${brand.id}`,
          value: `brand-${brand.id}`,
          text: brand.name,
          className: "brand-group-item",
          disabled: true,
          groupKey: group.id,
        })),
      ];
    });

    return [...allBrandsOption, ...groupOptions];
  };

  handleChange = (_e, { value: selectedValues }) => {
    const { value, showAllBrands, onChange } = this.props;
    const previousValue = value || [];
    let brandGroupIDs = selectedValues;

    if (showAllBrands) {
      if (brandGroupIDs.includes(ALL_BRANDS) && !previousValue.includes(ALL_BRANDS)) brandGroupIDs = [ALL_BRANDS];
      else if (brandGroupIDs.length > 1 && brandGroupIDs.includes(ALL_BRANDS)) brandGroupIDs = brandGroupIDs.filter(brandGroupID => brandGroupID !== ALL_BRANDS);
    }

    onChange(brandGroupIDs, this.getSelectedBrandGroups(brandGroupIDs));
  };

  renderLabel = option => ({ content: option.text, className: "brand-group-label" });

  render() {
    const { t, value, disabled } = this.props;
    const { isLoading } = this.state;

    return (
      <Dropdown
        className="BrandGroupDropdown"
        fluid
        selection
        multiple
        search={searchBrandGroups}
        disabled={disabled}
        loading={isLoading}
        value={value || []}
        options={this.getOptions()}
        placeholder={t("select_brand_group").message || "Select Brand Group"}
        onChange={this.handleChange}
        renderLabel={this.renderLabel}
      />
    );
  }
}

export default withTranslation()(BrandGroupDropdown);
